game.moveAnyTile = function(params) {
  "use strict";

  var tiles;

  if (params.pushing === true) {
    tiles = this.getMovableTiles({
      pushing: false,
      moving: true,
      direction: params.direction
    }).concat(this.getMovableTiles({
      pushing: true,
      moving: false,
      direction: params.direction
    }).sort(function(t1, t2) {
      return t1.canPush.n - t2.canPush.n;
    }))
  } else {
    tiles = this.getMovableTiles({
      pushing: false,
      moving: true,
      direction: params.direction
    })
  };

  for (var i = 0; i < tiles.length; i++) {
    this.moveTile(tiles[i], {
      transitions: false,
      force: false,
      refresh: false
    });
  }

  if (tiles.length) {
    this.refresh({
      transitionDuration: params.transitionDuration || this.config.transitionDuration.byKeyboard
    });
  }

  return tiles;
};
